module.exports = __webpack_public_path__ + "img/UZ.cf1979eb.svg";